// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { IdlSourceFile, IdlSourceFileT, verifyIdlSourceFile } from "./idl-source-file";
import { Interface } from "./interface";

/**
 * The uploaded sources: the main IDL, its includes, the optional companion
 * controller IDL, and the optional events XML.
 */
export class IdlBundle implements flatbuffers.IUnpackableObject<IdlBundleT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): IdlBundle {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsIdlBundle(bb: flatbuffers.ByteBuffer, obj?: IdlBundle): IdlBundle {
    return (obj || new IdlBundle()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsIdlBundle(bb: flatbuffers.ByteBuffer, obj?: IdlBundle): IdlBundle {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new IdlBundle()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  main(obj?: IdlSourceFile): IdlSourceFile | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new IdlSourceFile()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  includes(index: number, obj?: IdlSourceFile): IdlSourceFile | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new IdlSourceFile()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  includesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  controller(obj?: IdlSourceFile): IdlSourceFile | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset
      ? (obj || new IdlSourceFile()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  eventsXml(obj?: IdlSourceFile): IdlSourceFile | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset
      ? (obj || new IdlSourceFile()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  iface(): Interface | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : null;
  }

  schemaVersion(): string | null;
  schemaVersion(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  schemaVersion(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startIdlBundle(builder: flatbuffers.Builder) {
    builder.startObject(6);
  }

  static addMain(builder: flatbuffers.Builder, mainOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, mainOffset, 0);
  }

  static addIncludes(builder: flatbuffers.Builder, includesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, includesOffset, 0);
  }

  static createIncludesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startIncludesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addController(builder: flatbuffers.Builder, controllerOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, controllerOffset, 0);
  }

  static addEventsXml(builder: flatbuffers.Builder, eventsXmlOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, eventsXmlOffset, 0);
  }

  static addIface(builder: flatbuffers.Builder, iface: Interface) {
    builder.addFieldInt8(4, iface, null);
  }

  static addSchemaVersion(builder: flatbuffers.Builder, schemaVersionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, schemaVersionOffset, 0);
  }

  static endIdlBundle(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // main
    return offset;
  }

  unpack(): IdlBundleT {
    return new IdlBundleT(
      this.main() !== null ? this.main()!.unpack() : null,
      this.bb!.createObjList<IdlSourceFile, IdlSourceFileT>(
        this.includes.bind(this),
        this.includesLength(),
      ),
      this.controller() !== null ? this.controller()!.unpack() : null,
      this.eventsXml() !== null ? this.eventsXml()!.unpack() : null,
      this.iface(),
      this.schemaVersion(),
    );
  }

  unpackTo(_o: IdlBundleT): void {
    _o.main = this.main() !== null ? this.main()!.unpack() : null;
    _o.includes = this.bb!.createObjList<IdlSourceFile, IdlSourceFileT>(
      this.includes.bind(this),
      this.includesLength(),
    );
    _o.controller = this.controller() !== null ? this.controller()!.unpack() : null;
    _o.eventsXml = this.eventsXml() !== null ? this.eventsXml()!.unpack() : null;
    _o.iface = this.iface();
    _o.schemaVersion = this.schemaVersion();
  }

  unpackFields(...fields: string[]): IdlBundleT {
    const t = new IdlBundleT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("main")) {
      t.main = this.main() !== null ? this.main()!.unpack() : null;
    }
    if (fieldSet.has("includes")) {
      t.includes = this.bb!.createObjList<IdlSourceFile, IdlSourceFileT>(
        this.includes.bind(this),
        this.includesLength(),
      );
    }
    if (fieldSet.has("controller")) {
      t.controller = this.controller() !== null ? this.controller()!.unpack() : null;
    }
    if (fieldSet.has("events_xml")) {
      t.eventsXml = this.eventsXml() !== null ? this.eventsXml()!.unpack() : null;
    }
    if (fieldSet.has("iface")) {
      t.iface = this.iface();
    }
    if (fieldSet.has("schema_version")) {
      t.schemaVersion = this.schemaVersion();
    }
    return t;
  }
}

export class IdlBundleT implements flatbuffers.IGeneratedObject {
  constructor(
    public main: IdlSourceFileT | null = null,
    public includes: IdlSourceFileT[] = [],
    public controller: IdlSourceFileT | null = null,
    public eventsXml: IdlSourceFileT | null = null,
    public iface: Interface | null = null,
    public schemaVersion: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.main === null || this.main === undefined) {
      throw new Error('Required field "main" is not set');
    }
    const main = this.main !== null ? this.main!.pack(builder) : 0;
    const includes = IdlBundle.createIncludesVector(
      builder,
      builder.createObjectOffsetList(this.includes),
    );
    const controller = this.controller !== null ? this.controller!.pack(builder) : 0;
    const eventsXml = this.eventsXml !== null ? this.eventsXml!.pack(builder) : 0;
    const schemaVersion =
      this.schemaVersion !== null ? builder.createString(this.schemaVersion!) : 0;

    IdlBundle.startIdlBundle(builder);
    IdlBundle.addMain(builder, main);
    IdlBundle.addIncludes(builder, includes);
    IdlBundle.addController(builder, controller);
    IdlBundle.addEventsXml(builder, eventsXml);
    if (this.iface !== null) IdlBundle.addIface(builder, this.iface);
    IdlBundle.addSchemaVersion(builder, schemaVersion);

    return IdlBundle.endIdlBundle(builder);
  }

  clone(): IdlBundleT {
    const obj = new IdlBundleT();
    obj.main = this.main !== null ? this.main!.clone() : null;
    obj.includes = this.includes.map((e) => e.clone());
    obj.controller = this.controller !== null ? this.controller!.clone() : null;
    obj.eventsXml = this.eventsXml !== null ? this.eventsXml!.clone() : null;
    obj.iface = this.iface;
    obj.schemaVersion = this.schemaVersion;
    return obj;
  }

  equals(other: IdlBundleT): boolean {
    if (this.main !== null && other.main !== null) {
      if (!this.main!.equals(other.main!)) return false;
    } else if (this.main !== other.main) return false;
    if (this.includes.length !== other.includes.length) return false;
    for (let i = 0; i < this.includes.length; i++) {
      const a = this.includes[i];
      const b = other.includes[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.controller !== null && other.controller !== null) {
      if (!this.controller!.equals(other.controller!)) return false;
    } else if (this.controller !== other.controller) return false;
    if (this.eventsXml !== null && other.eventsXml !== null) {
      if (!this.eventsXml!.equals(other.eventsXml!)) return false;
    } else if (this.eventsXml !== other.eventsXml) return false;
    if (this.iface !== other.iface) return false;
    if (this.schemaVersion !== other.schemaVersion) return false;
    return true;
  }
}

export function verifyIdlBundle(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyIdlSourceFile(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "main");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyIdlSourceFile);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 8);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyIdlSourceFile(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 10);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyIdlSourceFile(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkScalarField(tablePos, 12, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
